import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  RrcLocationProfileInspector,
  RrcLocationProfilesPage,
} from '@ots-frontend/ots-ui-tw';
export const RrcLocationProfileKeyProfilePageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcLocationProfileKeyProfilePage
      profileKey={params.get('key') ?? undefined}
      tenantCode={params.get('tenantCode') ?? undefined}
    />
  );
};
export const RrcLocationProfileKeyProfilePage = ({
  profileKey,
  tenantCode,
}: {
  profileKey?: string;
  tenantCode?: string;
}) => {
  const navigate = useNavigate();
  return (
    <RrcLocationProfileInspector
      profileKey={profileKey}
      tenantCode={tenantCode}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
export const RrcLocationProfilesPageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcLocationProfilesPage
      locationId={params.get('locationId') ?? undefined}
      locationType={params.get('locationType') ?? undefined}
    />
  );
};
